// Base configuration
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const project_name = process.env.REACT_APP_PROJECT_NAME;
export const coachPortalUrl = process.env.REACT_APP_COACH_PORTAL_URL;
